// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1om8p","col":"styles_col__IO9dx"};